<template>
  <li>
    <router-link :to="{ name: 'articles-tree', params: {space_id: space_id, article_id: data.id}}">{{ data.name }}</router-link>
    <ul v-if="data.tree && data.tree.length">
      <li v-for="item in data.tree">
        <tree-item :space_id="space_id" :parent_id="data.id" :data="item"></tree-item>
      </li>
      <li class="articles_tree__new">
        <router-link :to="{ name: 'articles-edit', params: {space_id: space_id, article_id: 0}, query: {parent_id: data.id}}">Add article</router-link>
      </li>
    </ul>
  </li>
</template>

<script>
  import item from '@/components/spaces/item'

  export default {
    name: 'tree-item',
    props: ['data', 'space_id'],
    components: {
      'tree-item': item
    },
  }
</script>
